import { render, staticRenderFns } from "./RadiusOtp.vue?vue&type=template&id=27cf5930&"
import script from "./RadiusOtp.vue?vue&type=script&lang=ts&"
export * from "./RadiusOtp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports